export default {
  namespaced: true,
  state: { levels: [] },
  mutations: {
    SET_LEVELS: (state, levels) => {
      state.levels = levels;
    },
    ADD_LEVELS: (state, level) => {
      const index = state.levels.findIndex(l => l.to.query.childLevel == level.to.query.childLevel);

      if (index > -1) {
        state.levels.splice(index);
      }
      state.levels.push(level);
    },
  },
  actions: {
    ADDLEVELS: (store, level) => {
      store.commit('ADD_LEVELS', level);
    },
    RESETLEVELS: (store) => {
      store.commit('SET_LEVELS', []);
    },
  },
  getters: { levels: state => state.levels },
};
